export enum TipoPlano {
  REP = 'REP',
  DAP = 'DAP',
  QUI = 'QUI',
}
